
/*
  This file is auto-generated by generate-icon-components.js. Do not edit it manually.
*/
import { html, css, LitElement } from "lit";
import { customElement, property } from "lit/decorators.js";

export const FhiIconGearSelector = "fhi-icon-gear";

/**
 * ## FhiIconGear
 * 
 * {@link https://designsystem.fhi.no/?path=/docs/ikoner--docs}
 * 
 * @tag fhi-icon-gear
 * @element fhi-icon-gear
 */
@customElement(FhiIconGearSelector)
export class FhiIconGear extends LitElement {

  /**
   * Sets the color for the icon.
   * Should preferably be a color token. See [Color Tokens](https://designsystem.fhi.no/?path=/docs/design-tokens-farger--docs)
   * @type {string}
   */ 
  @property({ type: String }) color: string = "currentcolor";

  /**
   * Sets the size of the icon. Can be one of the predefined sizes, a number value, rem or px.
   * Number values are treated as px.
   * @type { 'xsmall' | 'small' | 'medium' | 'large' | number | string}
   */
  @property({ type: String }) size: 'xsmall' | 'small' | 'medium' | 'large' | number | `${number}px` | `${number}rem` = 'medium';

  private get _size(): string {
    switch (this.size) {
      case 'xsmall': 
        return '1rem'; 
      case 'small':
        return '1.25rem';
      case 'medium':
        return '1.5rem'; 
      case 'large':
        return '2rem'; 
      default:
        if (String(this.size).endsWith('px') || String(this.size).endsWith('rem')) {
          return String(this.size);
        }
        if (isNaN(Number(this.size))) {
          console.warn(`Invalid size value: ${this.size}. Falling back to default size '1.5rem'.`)
          return '1.5rem';
        }
        return `${this.size}px`;
    }
  }

  render() {
    return html`
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="${this._size}" height="${this._size}" fill="${this.color}"><path fill-rule="evenodd" d="M18.32 11.278a6.3 6.3 0 0 1 0 1.444l-.032.234a1.84 1.84 0 0 0 .433 1.513l1.085 1.207a.25.25 0 0 1 .03.292l-.574.992a.25.25 0 0 1-.275.117l-1.628-.39a1.84 1.84 0 0 0-1.521.33 6.2 6.2 0 0 1-1.352.766 1.86 1.86 0 0 0-1.004.965l-.074.203-.477 1.62a.25.25 0 0 1-.24.179h-1.16a.25.25 0 0 1-.24-.18l-.478-1.619a1.82 1.82 0 0 0-.899-1.084l-.179-.084a6 6 0 0 1-1.034-.544l-.318-.221a1.86 1.86 0 0 0-1.313-.367l-.208.038-1.823.435a.25.25 0 0 1-.224-.056l-.05-.062-.515-.888a.25.25 0 0 1 .031-.293l1.22-1.356.132-.167c.282-.405.369-.895.3-1.345a6.3 6.3 0 0 1 0-1.914l.02-.194A1.82 1.82 0 0 0 5.5 9.53L4.281 8.175a.25.25 0 0 1-.03-.293l.514-.888.05-.062a.25.25 0 0 1 .224-.056l1.823.436.208.037c.485.055.952-.098 1.313-.367a6.2 6.2 0 0 1 1.352-.765c.486-.2.912-.606 1.078-1.168l.478-1.62.035-.073a.25.25 0 0 1 .204-.106h1.162a.25.25 0 0 1 .239.18l.477 1.619.075.203c.199.458.578.79 1.003.965a6.2 6.2 0 0 1 1.352.765l.161.109c.39.233.872.338 1.36.221l1.628-.39a.25.25 0 0 1 .275.118l.574.992.028.074a.25.25 0 0 1-.015.152l-.043.066-1.085 1.207a1.84 1.84 0 0 0-.433 1.513zm1.49 1.615a7.8 7.8 0 0 0 0-1.786l-.04-.29c-.02-.131.019-.23.067-.283l1.084-1.207.09-.108a1.75 1.75 0 0 0 .19-1.814l-.067-.125-.574-.99a1.75 1.75 0 0 0-1.921-.826l-1.63.39a.3.3 0 0 1-.198-.028l-.078-.047a7.7 7.7 0 0 0-1.676-.949.38.38 0 0 1-.186-.151l-.023-.055-.479-1.62a1.75 1.75 0 0 0-1.678-1.254h-1.16a1.75 1.75 0 0 0-1.633 1.118l-.046.137-.478 1.619c-.02.07-.085.154-.209.205a7.7 7.7 0 0 0-1.678.95.37.37 0 0 1-.218.08l-.058-.005-1.823-.437a1.75 1.75 0 0 0-1.844.704l-.077.121-.515.889a1.75 1.75 0 0 0 .213 2.046l1.22 1.356a.3.3 0 0 1 .07.19l-.005.092a7.8 7.8 0 0 0 0 2.37.37.37 0 0 1-.032.233l-.033.049-1.22 1.356a1.75 1.75 0 0 0-.213 2.046l.515.889.077.12a1.75 1.75 0 0 0 1.844.705l1.823-.436.058-.006c.063 0 .14.021.218.08l.395.274q.606.396 1.283.676l.082.043a.3.3 0 0 1 .127.162l.478 1.62a1.75 1.75 0 0 0 1.678 1.254h1.162a1.75 1.75 0 0 0 1.677-1.255l.479-1.619.023-.055a.38.38 0 0 1 .186-.151 7.7 7.7 0 0 0 1.676-.95c.105-.077.208-.09.277-.073l1.629.39a1.75 1.75 0 0 0 1.92-.826l.575-.991a1.75 1.75 0 0 0-.213-2.047l-1.084-1.207a.34.34 0 0 1-.066-.282zM12 9.75a2.25 2.25 0 1 1 0 4.5 2.25 2.25 0 0 1 0-4.5m0 6a3.75 3.75 0 1 0 0-7.5 3.75 3.75 0 0 0 0 7.5" clip-rule="evenodd"/></svg>
    `;
  }
      
  static styles = css`
    :host {
      display: flex;
      max-height: min-content;
      max-width: min-content;
    }
  `;
  }
